import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import EditorHelpers from "../../common/EditorHelpers";
import l10n from '../../../lang/locallang';

export const headingSection = async (param, is_public = false) => {
    const {heading} = l10n.editor;
    param.class = param.class ? param.class : 'editor-section';
    param.content = param.content && param.content.text ? param.content.text : heading;
    // Check if content is provided, otherwise fetch AI placeholder
    // if (param.content && param.content.text) {
    //     param.content = param.content.text;
    // } else {
    //     param.content = await aiContent.requestForAIPlaceholder('headingSection', param.topic, param.lesson_name);
    // }
    param.style = param.style ? param.style : '';
    param.section = 'headingSection';
    param.component = `<div class="editor-section_container ${!is_public ? `fr-editor-container` : ''}">
        <h2 class="fr-editor-heading-h2">${EditorHelpers.fixEncoding(param.content)}</h2>
    </div>`;
    if (is_public) {
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}
